export default "__VITE_ASSET__D6u6u0Hu__"